import asset_3d_park_xc from "./xc_mapa.001.glb";
import asset_3d_park_xh from "./xel_ha_park.gltf";
import asset_3d_hx from "./hx_map.glb";

export const jltfAssets = {
    "xc": {
        asset: asset_3d_park_xc,
        scalar: 27.5,
        position: { x: -69, y: +98, z: -120 }
    },
    "xh": {
        asset: asset_3d_park_xh,
        scalar: 25.5,
        position: { x: -60, y: -78, z: -120 }
    },
    "hxm": {
        asset: asset_3d_hx,
        scalar: 17.7,
        position: { x: -150, y: 245, z: -120 }
    },
    "hxa": {
        asset: asset_3d_hx,
        scalar: 17.7,
        position: { x: -150, y: 245, z: -120 }
    }
}